import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';

import { BizzmineComponent } from './bizzmine.component';
import { BizzmineRoutingModule } from './bizzmine-routing.module';

@NgModule({
    declarations: [
        BizzmineComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule,
        BizzmineRoutingModule
    ],
    exports: [
        BizzmineComponent
    ]
})
export class BizzmineModule { }
